import React from "react";

const EnvironmentsDashboard = props => {
  return (
    <div className="environments-dashboard-container">
      {props.labels}
    </div>
  );
};

export default EnvironmentsDashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard-home/EnvironmentsDashboard.js